import { m } from 'motion/react';
import {
  containerVariants,
  itemVariants,
  viewPort,
} from '../../../utils/framer';

interface ListItem {
  title: string;
  text: string;
}

interface ContentTextBoxProps {
  title: string;
  description?: string;
  backgroundColor?: string;
  titleColor?: string;
  textColor?: string;
  listItems?: ListItem[];
  children?: React.ReactNode;
  className?: string;
}

export const ContentTextBox: React.FC<ContentTextBoxProps> = ({
  title,
  description,
  listItems,
  children,
  backgroundColor = 'bg-white',
  titleColor = 'text-black',
  textColor = 'text-gray-600',
  className = '',
}) => {
  return (
    <m.div
      initial="hidden"
      whileInView="visible"
      viewport={viewPort}
      variants={containerVariants}
      className={`flex flex-col justify-center gap-8 h-full px-6 py-8 lg:p-8 xl:px-12 ${className} ${backgroundColor}`}
    >
      <m.h2 variants={itemVariants} className={titleColor}>
        {title}
      </m.h2>
      {description && (
        <m.p variants={itemVariants} className={`${textColor}`}>
          {description}
        </m.p>
      )}
      {listItems ? (
        <m.ol
          initial="hidden"
          whileInView="visible"
          viewport={viewPort}
          variants={containerVariants}
          className="list-decimal ml-4"
        >
          {listItems.map((item, index) => (
            <m.li variants={itemVariants} key={index}>
              <p className="font-bold text-xl">{item.title}</p>
              <p className="text-gray-600 mb-2 md:mb-4">{item.text}</p>
            </m.li>
          ))}
        </m.ol>
      ) : (
        <m.div variants={itemVariants}>{children}</m.div>
      )}
    </m.div>
  );
};
